import {Component, OnInit} from '@angular/core';
import {RiskGroupSubject} from '../../model';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {RegistriesService} from "../../service";
import {TableService, VisitedService} from "@amlCore/services";


@Component({
  selector: 'app-registry-riskGroup-subject',
  templateUrl: './riskGroupSubject.component.html'
})
export class RiskGroupSubjectComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = false;

  constructor(private regSrv: RegistriesService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'riskDate', dir: 'ASC'});
  }

  private id: string; // уникальный идентификатор
  public isAll = false; // поиск по всем перечням
  public riskGroupSubjectList: Array<RiskGroupSubject> = [];
  public goBack = Utils.goBack;
  placeholder = 'Поиск по ИНН';

  ngOnInit() {
    /*this.id = this.activatedRoute.snapshot.params.id;
    if (this.id === undefined) {
      this.isAll = true;
    }*/
    this.activatedRoute.params.subscribe(params => {
    this.id = params.id;
      this.activatedRoute.queryParams.subscribe((data) => {
	   this.isAll = !this.id;
	   const paramsData = this.syncParams(data);
       paramsData.id = this.id;
       this.loadList(paramsData);
     });
    });
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter});
    filter["isAll"] = this.isAll;
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  private loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.regSrv.getRiskGroupSubjectList(queryParams).subscribe(data => {
        this.riskGroupSubjectList = data.content;
        this.total = data.totalElements ?? data.totalSize;
    });

  }

}
